import Vue from 'vue'
import Router from 'vue-router'
import router from '@/router'
import robot from '@/views/robot/index.vue'
import {
  getToken
} from '../utils/auth.js'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'robot',
      component: robot,
      meta: {
        title: "绩效AI",
      }
    },

  ]
})
router.beforeEach((to, from, next) => {
  console.log("to", to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});








// WEBPACK FOOTER //
// ./src/router/index.js